import { I18n } from '@editorjs/editorjs/types/api';

export type ButtonArgs = {
  text: string;
  onClick?: () => Promise<void>;
  svg?: string;
  disabled?: boolean;
};

export default class ButtonDomFactory {
  public readonly i18n: I18n;

  constructor(i18n: I18n) {
    this.i18n = i18n;
  }

  public createButton({ text, svg, disabled }: ButtonArgs) {
    const button = document.createElement('button');
    button.type = 'button';
    button.disabled = disabled || false;
    button.classList.add('activity-button');
    svg && button.appendChild(this.createButtonIcon(svg));
    button.appendChild(this.createButtonText(text));
    return button;
  }

  public createButtonText(text: string) {
    const buttonText = document.createElement('span');
    buttonText.textContent = text;
    return buttonText;
  }

  public createButtonIcon(svg: string) {
    const buttonIcon = document.createElement('div');
    buttonIcon.innerHTML = svg;

    return buttonIcon;
  }
}
